// extracted by mini-css-extract-plugin
module.exports = {"EmptyMsgGrid":"empty-message_EmptyMsgGrid__ZdV6-","EmptyMsgGridSmall":"empty-message_EmptyMsgGridSmall__2CyBG","MsgText":"empty-message_MsgText__169QT"};